module.exports = __webpack_public_path__ + "static/media/Game-Art-v2-peices_balloon.276e1d3c.png";